/*
 * PEV — pev-brevo (Ticket #159): first-party Progressive Enhancement fuer das Brevo-DOI-Formular
 * (snippets/pev-brevo-form.liquid).
 *
 * Problem des reinen nativen POST: Brevos /serve/-Endpoint liefert ohne den Query-Param
 * `?isAjax=1` eine Navigations-/HTML-Antwort → die Seite laedt weg auf eine unschoene Brevo-Seite.
 * Brevos eigenes main.js postet dagegen an `<action>?isAjax=1` (XHR + FormData) und liest eine
 * JSON-Antwort. Genau das machen wir hier selbst — OHNE Brevos main.js zu laden (das hardcodet
 * globale ids #sib-form/#EMAIL → braeche unsere eindeutigen ids/AC5, und lädt Tracker).
 *
 * Consent/DSGVO: Es passiert NICHTS beim Laden. Der fetch feuert ausschliesslich beim vom Nutzer
 * ausgeloesten Submit (= die freiwillige Einwilligungshandlung). `credentials` bleibt Default
 * (cross-origin ⇒ KEINE Cookies gesendet/gesetzt). Der /serve/?isAjax=1-Endpoint ist CORS-faehig
 * (Access-Control-Allow-Origin spiegelt die Origin). Ohne JS bleibt der native POST als Fallback.
 */
(function () {
  if (window.customElements && customElements.get('pev-brevo-form')) return;

  class PevBrevoForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form.pev-brevo__form');
      this.statusEl = this.querySelector('[data-pev-brevo-status]');
      this.button = this.querySelector('button[type="submit"]');
      if (!this.form || this.form.dataset.pevEnhanced === 'true') return;
      this.form.dataset.pevEnhanced = 'true';
      this.form.addEventListener('submit', this.onSubmit.bind(this));
    }

    onSubmit(event) {
      // Immer die native Navigation verhindern (sonst laedt die Seite auf Brevos Nicht-AJAX-Antwort weg).
      event.preventDefault();
      // Ungueltige Eingabe ⇒ native Validierungs-UI zeigen, kein Request.
      if (!this.form.checkValidity()) {
        this.form.reportValidity();
        return;
      }

      var action = this.form.getAttribute('action') || '';
      if (!action) return; // ohne Ziel nichts tun (fail-safe)
      var url = action + (action.indexOf('?') === -1 ? '?' : '&') + 'isAjax=1';

      this.setBusy(true);
      var self = this;
      fetch(url, {
        method: 'POST',
        body: new FormData(this.form),
        headers: { Accept: 'application/json' }
        // credentials: Default 'same-origin' ⇒ cross-origin sendet/empfaengt KEINE Cookies
      })
        .then(function (response) {
          return response.json().then(
            function (data) {
              return { ok: response.ok, data: data };
            },
            function () {
              // Antwort nicht als JSON lesbar ⇒ nicht als Erfolg werten (kein falsches "geschafft")
              return { ok: false, data: null };
            }
          );
        })
        .then(function (result) {
          // Erfolg NUR bei HTTP-ok UND Brevos success:true; alles andere ⇒ erneut versuchen
          if (result.ok && result.data && result.data.success === true) {
            self.showSuccess();
          } else {
            self.showError(result.data && result.data.message);
          }
        })
        .catch(function () {
          // echter Netzwerkfehler ⇒ Nutzer soll es erneut versuchen koennen
          self.showError();
        })
        .then(function () {
          self.setBusy(false);
        });
    }

    setBusy(busy) {
      if (!this.button) return;
      this.button.toggleAttribute('disabled', busy);
      this.button.setAttribute('aria-busy', busy ? 'true' : 'false');
    }

    showSuccess() {
      if (this.form) this.form.hidden = true;
      if (!this.statusEl) return;
      this.statusEl.className = 'pev-brevo__status pev-brevo__status--success';
      this.statusEl.textContent =
        this.getAttribute('data-success') ||
        'Fast geschafft. Bitte bestaetige deine Anmeldung ueber den Link in der E-Mail, die wir dir gerade geschickt haben.';
      this.statusEl.hidden = false;
      try {
        this.statusEl.focus();
      } catch (e) {}
    }

    showError(message) {
      if (!this.statusEl) return;
      this.statusEl.className = 'pev-brevo__status pev-brevo__status--error';
      this.statusEl.textContent =
        message || 'Das hat leider nicht geklappt. Bitte versuche es gleich noch einmal.';
      this.statusEl.hidden = false;
      this.setBusy(false);
    }
  }

  if (window.customElements) {
    customElements.define('pev-brevo-form', PevBrevoForm);
  }
})();
